var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.847 285.372L67 262.735",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.163 332.481L70.2344 338.763",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.583 285.372L432.43 262.735",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.267 332.481L429.195 338.763",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.429 279.421C253.514 266.612 232.025 272.953 221.368 279.34C219.692 280.345 219.656 282.663 221.207 283.852C230.064 290.642 243.529 299.89 249.024 299.89C255.802 299.89 268.906 290.52 276.808 284.062C278.358 282.796 278.176 280.397 276.429 279.421Z",
    fill: "#1C1B1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.024 296.055V319.061L216.415 339",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.906 296.055V319.061L282.515 339",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M457.715 456L422.715 421",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 364.797,
    cy: 353.082,
    r: 90.5819,
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.714 313C405.175 313 409.602 316.473 409.602 320.758L409.602 331.101C409.602 335.386 405.175 338.859 399.714 338.859C394.254 338.859 389.827 335.386 389.827 331.101L389.827 320.758C389.827 316.473 394.254 313 399.714 313Z",
    fill: "#1C1B1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.714 392.099C405.175 392.099 409.602 395.981 409.602 400.769L409.602 412.33C409.602 417.118 405.175 421 399.714 421C394.254 421 389.827 417.118 389.827 412.33L389.827 400.769C389.827 395.981 394.254 392.099 399.714 392.099Z",
    fill: "#1C1B1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.594 328.104C440.92 331.43 440.92 336.823 437.594 340.149L429.564 348.179C426.238 351.505 420.845 351.505 417.519 348.179C414.193 344.853 414.193 339.46 417.519 336.134L425.549 328.104C428.875 324.778 434.268 324.778 437.594 328.104Z",
    fill: "#1C1B1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.58 385.116C383.906 388.442 383.906 393.835 380.58 397.161L372.55 405.191C369.224 408.517 363.831 408.517 360.505 405.191C357.179 401.865 357.179 396.472 360.505 393.146L368.535 385.116C371.861 381.79 377.254 381.79 380.58 385.116Z",
    fill: "#1C1B1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.819 328.103C364.146 324.777 369.538 324.777 372.864 328.103L380.894 336.133C384.221 339.459 384.221 344.852 380.894 348.178C377.568 351.504 372.176 351.504 368.849 348.178L360.819 340.148C357.493 336.822 357.493 331.429 360.819 328.103Z",
    fill: "#1C1B1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.831 385.116C421.157 381.79 426.55 381.79 429.876 385.116L437.906 393.146C441.232 396.472 441.232 401.865 437.906 405.191C434.58 408.517 429.187 408.517 425.861 405.191L417.831 397.161C414.505 393.835 414.505 388.442 417.831 385.116Z",
    fill: "#1C1B1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.715 365.479C345.715 360.858 349.188 357.113 353.473 357.113L363.816 357.113C368.101 357.113 371.574 360.858 371.574 365.479C371.574 370.1 368.101 373.845 363.816 373.845L353.473 373.845C349.188 373.845 345.715 370.1 345.715 365.479Z",
    fill: "#1C1B1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.813 365.479C424.813 360.858 428.695 357.113 433.484 357.113L445.044 357.113C449.833 357.113 453.715 360.858 453.715 365.479C453.715 370.1 449.833 373.845 445.044 373.845L433.484 373.845C428.695 373.845 424.813 370.1 424.813 365.479Z",
    fill: "#1C1B1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M433.715 365.5C433.715 384.002 418.493 399 399.715 399C380.937 399 365.715 384.002 365.715 365.5C365.715 346.998 380.937 332 399.715 332C418.493 332 433.715 346.998 433.715 365.5Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M414.616 365.451C414.616 373.432 408.146 379.901 400.166 379.901C392.185 379.901 385.715 373.432 385.715 365.451C385.715 357.47 392.185 351 400.166 351C408.146 351 414.616 357.47 414.616 365.451Z",
    fill: "#1C1B1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.795 299C317.331 299 319.387 300.613 319.387 302.603L319.387 307.407C319.387 309.397 317.331 311.01 314.795 311.01C312.259 311.01 310.203 309.397 310.203 307.407L310.203 302.603C310.203 300.613 312.259 299 314.795 299Z",
    fill: "#1C1B1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.795 335.737C317.331 335.737 319.387 337.54 319.387 339.764L319.387 345.133C319.387 347.357 317.331 349.16 314.795 349.16C312.259 349.16 310.203 347.357 310.203 345.133L310.203 339.764C310.203 337.54 312.259 335.737 314.795 335.737Z",
    fill: "#1C1B1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.388 306.015C333.933 307.56 333.933 310.064 332.388 311.609L328.658 315.339C327.114 316.884 324.609 316.884 323.064 315.339C321.519 313.794 321.519 311.289 323.064 309.745L326.794 306.015C328.339 304.47 330.843 304.47 332.388 306.015Z",
    fill: "#1C1B1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.907 332.494C307.452 334.039 307.452 336.544 305.907 338.088L302.178 341.818C300.633 343.363 298.129 343.363 296.584 341.818C295.039 340.273 295.039 337.768 296.584 336.224L300.313 332.494C301.858 330.949 304.363 330.949 305.907 332.494Z",
    fill: "#1C1B1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.73 306.015C298.275 304.47 300.779 304.47 302.324 306.015L306.053 309.744C307.598 311.289 307.598 313.793 306.053 315.338C304.509 316.883 302.004 316.883 300.459 315.338L296.73 311.609C295.185 310.064 295.185 307.559 296.73 306.015Z",
    fill: "#1C1B1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.209 332.494C324.754 330.949 327.259 330.949 328.803 332.494L332.533 336.223C334.078 337.768 334.078 340.273 332.533 341.818C330.988 343.362 328.484 343.362 326.939 341.818L323.209 338.088C321.664 336.543 321.664 334.039 323.209 332.494Z",
    fill: "#1C1B1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.715 323.374C289.715 321.228 291.328 319.488 293.318 319.488L298.122 319.488C300.112 319.488 301.725 321.228 301.725 323.374C301.725 325.52 300.112 327.259 298.122 327.259L293.318 327.259C291.328 327.259 289.715 325.52 289.715 323.374Z",
    fill: "#1C1B1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.452 323.374C326.452 321.228 328.255 319.488 330.479 319.488L335.848 319.488C338.072 319.488 339.875 321.228 339.875 323.374C339.875 325.52 338.072 327.259 335.848 327.259H330.479C328.255 327.259 326.452 325.52 326.452 323.374Z",
    fill: "#1C1B1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.087 322.462C329.087 330.654 322.447 337.294 314.255 337.294C306.064 337.294 299.423 330.654 299.423 322.462C299.423 314.27 306.064 307.63 314.255 307.63C322.447 307.63 329.087 314.27 329.087 322.462Z",
    fill: "#D9D9D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M320.937 322.432C320.937 326.138 317.932 329.143 314.225 329.143C310.519 329.143 307.514 326.138 307.514 322.432C307.514 318.725 310.519 315.72 314.225 315.72C317.932 315.72 320.937 318.725 320.937 322.432Z",
    fill: "#1C1B1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M165.715 195C203.048 201.202 288.915 221.884 333.715 255",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M333.715 195C296.382 201.202 210.515 221.884 165.715 255",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.715 280C355.983 280 349.715 286.268 349.715 294C349.715 301.732 355.983 308 363.715 308C371.447 308 377.715 301.732 377.715 294C377.715 286.268 371.447 280 363.715 280Z",
    fill: "#1C1B1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.215 352C292.625 352 289.715 354.91 289.715 358.5C289.715 362.09 292.625 365 296.215 365C299.805 365 302.715 362.09 302.715 358.5C302.715 354.91 299.805 352 296.215 352Z",
    fill: "#1C1B1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.215 287C402.625 287 399.715 289.91 399.715 293.5C399.715 297.09 402.625 300 406.215 300C409.805 300 412.715 297.09 412.715 293.5C412.715 289.91 409.805 287 406.215 287Z",
    fill: "#1C1B1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.215 414C356.625 414 353.715 416.91 353.715 420.5C353.715 424.09 356.625 427 360.215 427C363.805 427 366.715 424.09 366.715 420.5C366.715 416.91 363.805 414 360.215 414Z",
    fill: "#1C1B1F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.215 380C304.998 380 296.715 388.283 296.715 398.5C296.715 408.717 304.998 417 315.215 417C325.432 417 333.715 408.717 333.715 398.5C333.715 388.283 325.432 380 315.215 380Z",
    fill: "#1C1B1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.715 361C326.953 361 324.715 363.239 324.715 366C324.715 368.761 326.953 371 329.715 371C332.476 371 334.715 368.761 334.715 366C334.715 363.239 332.476 361 329.715 361Z",
    fill: "#1C1B1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M359.11 114.416C370.209 112.772 395.119 115.156 405.971 137.846",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M359.11 137.643C370.209 135.999 393.269 144.752 404.121 167.443",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M139.604 114.416C128.506 112.772 103.596 115.156 92.7436 137.846",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M139.604 137.643C128.506 135.999 105.445 144.752 94.5934 167.443",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M131.513 159.427C117.697 139.08 123.53 94.0428 131.514 88.2477C139.498 82.4527 176.89 105.167 190.631 132.956",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M369.977 159.427C383.793 139.08 377.961 94.0428 369.977 88.2477C361.993 82.4527 324.601 105.167 310.86 132.956",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatNone);
export default __webpack_public_path__ + "static/media/피부과_cat_none.494beeeefee545f38625d5695bbe9462.svg";
export { ForwardRef as ReactComponent };